import type { BadgeProps } from 'antd'

export const walletTypeLabels: Record<string, string> = {
  SENDER: 'Отправители',
  TRANSIT: 'Транзитные',
  FINAL: 'Финальные',
  OWN: 'Свои кошельки',
}

type WalletStatus = {
  label: string
  badge: BadgeProps['status']
}

export const walletStatuses: Record<string, WalletStatus> = {
  CLEAN: { label: 'Чистый', badge: 'success' },
  SUSPICIOUS: { label: 'Подозрительный', badge: 'warning' },
  DANGEROUS: { label: 'Высокий AML-риск', badge: 'error' },
  BLOCKED: { label: 'Заблокирован', badge: 'default' },
  UNCHECKED: { label: 'Не проверен', badge: 'default' },
}

const walletCheckStatuses: Record<string, WalletStatus> = {
  NOT_CHECKED: { label: 'Не проверен', badge: 'default' },
  UNCHECKED: { label: 'Не проверен', badge: 'default' },
  CHECKING: { label: 'Проверяется', badge: 'processing' },
  COMPLETED: { label: 'Проверка завершена', badge: 'success' },
  ERROR: { label: 'Ошибка проверки', badge: 'error' },
}

export const getWalletStatus = (status: string): WalletStatus =>
  walletStatuses[status] ?? { label: status || 'Неизвестен', badge: 'default' }

export const getWalletCheckStatus = (status: string): WalletStatus =>
  walletCheckStatuses[status] ?? {
    label: status || 'Не проверен',
    badge: 'default',
  }

export const isWalletChecking = (checkStatus: string) =>
  checkStatus === 'CHECKING'

export const shortenWalletAddress = (address: string) =>
  address.length > 24 ? `${address.slice(0, 12)}…${address.slice(-8)}` : address

export const getWalletName = (name: string, address: string) =>
  name.trim() || shortenWalletAddress(address)

export const getWalletBalance = (balance: string | null, currency: string) =>
  balance ? `${balance} ${currency}` : 'Баланс недоступен'
